import api from '@/services/api';

export default {
  async getOccupancySummary(budgetIterationId, includeHistoricals) {
    try {
      let response = await api.get(`Occupancy/Summary?budgetIterationId=${ budgetIterationId }&includeHistoricals=${ includeHistoricals || false }`);
      if (response && response.status == 200 && response.data) {
        return response.data;
      }
      return [];
    } catch (ex) {
      console.error(ex);
      return [];
    }
  },
  // Model/Admin/Down
  async getModelAdminDownSummary(budgetIterationId) {
    try {
      let response = await api.get(`Occupancy/ModelAdminDown/Summary?budgetIterationId=${ budgetIterationId }`);
      if (response && response.status == 200 && response.data) {
        return response.data;
      }
      return [];
    } catch (ex) {
      console.error(ex);
      return [];
    }
  },
  async getModelAdminDownEntries(budgetIterationId, includeHistoricals) {
    try {
      let response = await api.get(`Occupancy/ModelAdminDown?budgetIterationId=${ budgetIterationId }&includeHistoricals=${ includeHistoricals || false }`);
      if (response && response.status == 200 && response.data) {
        return response.data;
      }
      return [];
    } catch (ex) {
      console.error(ex);
      return [];
    }
  },
  async setDefaultModelAdminDownEntries(budgetIterationId) {
    try {
        let response = await api.put(`Occupancy/ModelAdminDown/Defaults?budgetIterationId=${ budgetIterationId }`, null);
        if (response && response.status == 200 && response.data) {
          return response.data;
        }
        return false;
      } catch (ex) {
        console.error(ex);
        return false;
      }
  },
  // Move Ins/Move Outs
  async getMoveInsMoveOutsSummary(budgetIterationId, includeHistoricals) {
    try {
      let response = await api.get(`Occupancy/MoveInsMoveOuts/Summary?budgetIterationId=${ budgetIterationId }&includeHistoricals=${ includeHistoricals || false }`);
      if (response && response.status == 200 && response.data) {
        return response.data;
      }
      return [];
    } catch (ex) {
      console.error(ex);
      return [];
    }
  },
  async getMoveInsMoveOutsEntries(budgetIterationId, includeHistoricals) {
    try {
      let response = await api.get(`Occupancy/MoveInsMoveOuts?budgetIterationId=${ budgetIterationId }&includeHistoricals=${ includeHistoricals }`);
      if (response && response.status == 200 && response.data) {
        return response.data;
      }
      return [];
    } catch (ex) {
      console.error(ex);
      return [];
    }
  },
  async setDefaultMoveInsMoveOutsEntries(budgetIterationId) {
    try {
        let response = await api.put(`Occupancy/MoveInsMoveOuts/Defaults?budgetIterationId=${ budgetIterationId }`, null);
        if (response && response.status == 200 && response.data) {
          return response.data;
        }
        return false;
      } catch (ex) {
        console.error(ex);
        return false;
      }
  },
  // Actual Rent
  async getActualRentEntries(budgetIterationId) {
    try {
      let response = await api.get(`Occupancy/ActualRent?budgetIterationId=${ budgetIterationId }`);
      if (response && response.status == 200 && response.data) {
        return response.data;
      }
      return [];
    } catch (ex) {
      console.error(ex);
      return [];
    }
  },
  async setDefaultActualRentEntries(budgetIterationId) {
    try {
        let response = await api.put(`Occupancy/ActualRent/Defaults?budgetIterationId=${ budgetIterationId }`, null);
        if (response && response.status == 200 && response.data) {
          return response.data;
        }
        return false;
      } catch (ex) {
        console.error(ex);
        return false;
      }
  },
  // Rental Deductions
  async getRentalDeductionsEntries(budgetIterationId) {
    try {
      let response = await api.get(`Occupancy/RentalDeductions?budgetIterationId=${ budgetIterationId }`);
      if (response && response.status == 200 && response.data) {
        return response.data;
      }
      return [];
    } catch (ex) {
      console.error(ex);
      return [];
    }
  },
  async setDefaultRentalDeductionsEntries(budgetIterationId) {
    try {
      let response = await api.put(`Occupancy/RentalDeductions/Defaults?budgetIterationId=${ budgetIterationId }`, null);
      if (response && response.status == 200 && response.data) {
        return response.data;
      }
      return false;
    } catch (ex) {
      console.error(ex);
      return false;
    }
  },
  async updateOtherConcessionsEntries(budgetIterationId, otherConcessions, lastModifiedTimestamp) {
    try {
      let requestBody = {
        budgetIterationId: budgetIterationId,
        otherConcessionsEntries: otherConcessions,
        lastModifiedTimestamp: lastModifiedTimestamp
      };
      let response = await api.post('Occupancy/RentalDeductions/OtherConcessions', requestBody);
      if (response && response.status == 200 && response.data) {
        return response.data;
      }
      return false;
    } catch (ex) {
      console.error(ex);
      return false;
    }
  },
  async getFieldsUsedInCalculations(budgetIterationId) {
    try {
      let response = await api.get(`Occupancy/FieldsUsedInCalculations?budgetIterationId=${budgetIterationId}`);
      if (response && response.status == 200 && response.data) {
        return Object.keys(response.data);
      }
      return [];
    } catch (ex) {
      console.error(ex);
      return [];
    }
  }
}
